import * as React from 'react'
import { DownTime, DowntimePropertyName, AlarmGroup } from '../../../model/DownTime'
import ValidationMessageList from '../ValidationMessageList'
import { LockStatus } from '../../../model/DownTimeEnums'

type Props = {
  downtime: DownTime
  alarmGroups: AlarmGroup[]
  updateDowntime: (downtime: DownTime) => void
}

export class SubGroupCell extends React.Component<Props> {
  public render(): JSX.Element {
    const { downtime, alarmGroups, updateDowntime } = this.props
    const alarmGroup = alarmGroups && alarmGroups.find(group => group.name === downtime.group)

    if (downtime.lockStatus === LockStatus.notLocked) {
      return (
        <div>
          <select
            value={downtime.subGroup}
            onChange={e => {
              updateDowntime(new DownTime({ ...downtime, subGroup: e.target.value }))
            }}
            className="form-control"
          >
            {alarmGroup &&
              alarmGroup.subGroups &&
              alarmGroup.subGroups.map(subGroup => (
                <option value={subGroup} key={subGroup}>
                  {subGroup}
                </option>
              ))}
          </select>
          <ValidationMessageList property={DowntimePropertyName.SubGroup} downtime={downtime} />
        </div>
      )
    } else {
      return (
        <div>
          <p>{downtime.subGroup}</p>
          <ValidationMessageList property={DowntimePropertyName.SubGroup} downtime={downtime} />
        </div>
      )
    }
  }
}

export default SubGroupCell
